import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Icon } from '@99designs/common/components/Icon';
import { Button } from '@99designs/common/components/Button';
import { ButtonGroup, ButtonGroupItem } from '@99designs/common/components/ButtonGroup';
import DesignAction from './connected/design-action';

const actions = [
    {
        key: 'delete',
        icon: 'trash-2',
        label: 'delete_action',
    },
    {
        key: 'undoDelete',
        icon: 'undo-1',
        label: 'undo_delete_action',
    },
    {
        key: 'eliminate',
        icon: 'trash-2',
        label: 'eliminate_action',
    },
    {
        key: 'undoEliminate',
        icon: 'undo-1',
        label: 'undo_eliminate_action',
    },
    {
        key: 'award',
        icon: 'trophy-1',
        label: 'award_winner_action',
    },
    {
        key: 'withdraw',
        icon: 'trash-2',
        label: 'withdraw_design_action',
    },
    {
        key: 'undoWithdraw',
        icon: 'undo-1',
        label: 'undo_withdraw_action',
    },
    {
        key: 'addToFolio',
        icon: 'folio-add-1',
        label: 'add_to_folio_action',
    },
    {
        key: 'report',
        icon: 'exclamation-point-2',
        label: 'report_design_action',
    },
];

export class AdditionalDesignActions extends Component {
    constructor(props) {
        super(props);

        this.handleAction = this.handleAction.bind(this);
    }

    render() {
        if (!this.hasActions()) {
            return null;
        }

        return (
            <ButtonGroup variations={['design-actions']}>
                {this.renderActions()}
                <span
                    data-hidden
                    data-modal-name="entry-award-modal"
                    data-modal-content="#entry-award-modal"
                    ref={(awardNode) => {
                        this.awardNode = awardNode;
                    }}
                />
            </ButtonGroup>
        );
    }

    renderActions() {
        const actions = this.getActions();
        return actions.map((action) => {
            const icon = <Icon variations={[action.icon]} />;
            return (
                <ButtonGroupItem key={action.key}>
                    <Button
                        variations={[
                            'transparent',
                            'no-pad',
                            'icon-left',
                            `${action.key === 'delete' && 'danger'}`,
                        ]}
                        icon={icon}
                        onClick={() => this.handleAction(action.key)}
                    >
                        {this.context.intl.formatMessage({ id: action.label })}
                    </Button>
                </ButtonGroupItem>
            );
        });
    }

    handleAction(key) {
        switch (key) {
            case 'report':
                return this.props.onReportDesign();
            case 'delete':
                return this.props.onDeleteDesign();
            case 'undoDelete':
                return this.props.onUndoDelete();
            case 'withdraw':
                return this.props.onWithdrawDesign();
            case 'undoWithdraw':
                return this.props.onUndoWithdraw();
            case 'addToFolio':
                return this.props.onAddToFolio();
            case 'eliminate':
                return this.props.onEliminateDesign();
            case 'undoEliminate':
                return this.props.onUndoEliminate();
            case 'award':
                return this.props.onAwardWinner();
        }
    }

    hasActions() {
        return this.getActions().length > 0;
    }

    getActions() {
        const design = this.props.design;
        const showActions = {
            withdraw: !design.isWithdrawn && design.permission.canWithdraw,
            undoWithdraw: design.isWithdrawn && design.permission.canWithdraw,
            addToFolio: design.permission.canAddToFolio,
            delete: !design.isDeleted && design.permission.canDelete,
            undoDelete: design.isDeleted && design.permission.canDelete,
            eliminate: !design.isEliminated && design.permission.canEliminate,
            undoEliminate: design.isEliminated && design.permission.canEliminate,
            award: !design.isWinner && design.permission.canAward,
            report: design.permission.canReport,
        };
        return actions.filter((action) => showActions[action.key]);
    }
}
AdditionalDesignActions.propTypes = {
    design: PropTypes.object.isRequired,
    onReportDesign: PropTypes.func.isRequired,
    onDeleteDesign: PropTypes.func.isRequired,
    onUndoDelete: PropTypes.func.isRequired,
    onWithdrawDesign: PropTypes.func.isRequired,
    onUndoWithdraw: PropTypes.func.isRequired,
    onAddToFolio: PropTypes.func.isRequired,
    onEliminateDesign: PropTypes.func.isRequired,
    onUndoEliminate: PropTypes.func.isRequired,
    onAwardWinner: PropTypes.func.isRequired,
    activeUser: PropTypes.object,
};
AdditionalDesignActions.defaultProps = {
    activeUser: null,
};
AdditionalDesignActions.contextTypes = {
    intl: PropTypes.object,
};

export default DesignAction(AdditionalDesignActions);



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/design-details/components/additional-design-actions.jsx